<mat-spinner *ngIf="(!leadSource && !providerAgent); else form" style="margin: auto"></mat-spinner>
<ng-template #form>
  <form method="post" enctype="multipart/form-data" (ngSubmit)="onSubmit($event)" *ngIf="formState !== 'SUCCESS'">
    <h1 class="blue margin-bottom-4">Überleitungstool</h1>
    <div class="grid-container-1-1">
      <div class="w-100" *ngIf="providerAgentOptions">
        <h3>Überleitung erfolgt von</h3>

        <mat-form-field class="w-100" appearance="fill">
          <mat-label>Standort</mat-label>
          <mat-select [(ngModel)]="providerAgent" name="providerAgent">
            <mat-option *ngFor="let option of providerAgentOptions" [value]="option">
              {{option._embedded.office.name}} - {{option._embedded.activity.name}}
              ({{option._embedded.employee | employeeName}})
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <app-recipient class="w-100" [providerAgent]="providerAgent"
                     (preferredAgentSelected)="preferredAgent = $event"></app-recipient>
    </div>
    <app-lead-form
      (onValidChange)="formIsValid=$event"
      (files)="files = $event"
      [formState]="formState"></app-lead-form>
  </form>

  <div *ngIf="formState === 'SUCCESS'" class="w-100 text-center">
    <img src="assets/submit-icon.svg"/>
    <h1 class="black">Vielen Dank für Ihre Überleitung.<br/>
      Die Daten von
      {{getDativ(formData.get('mainApplicant_salutation')?.toString())}}
      {{formData.get('mainApplicant_firstName')}}
      {{formData.get('mainApplicant_lastName')}}
      werden an <br/>
      <strong>{{preferredAgent._embedded.employee.firstName}} {{preferredAgent._embedded.employee.lastName}}</strong>
      übermittelt.
    </h1>
    <br/>
    <a [href]="getEmailLinkWithData()">
      <button mat-flat-button color="accent">An weitere Person(en) schicken</button>
    </a>
    &nbsp;&nbsp;
    <button mat-flat-button color="primary" (click)="resetForm()" style="margin-top: 1em;">Weiteren Kunden übermitteln
    </button>
  </div>
</ng-template>
